import { render, staticRenderFns } from "./memberLinkPhone.vue?vue&type=template&id=e35ad800&scoped=true&"
import script from "./memberLinkPhone.vue?vue&type=script&lang=js&"
export * from "./memberLinkPhone.vue?vue&type=script&lang=js&"
import style0 from "./memberLinkPhone.vue?vue&type=style&index=0&id=e35ad800&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35ad800",
  null
  
)

export default component.exports